import { Injectable } from "@angular/core";
import { DxButtonModule } from "devextreme-angular";
import notify from "devextreme/ui/notify";
import { NotifyType } from "./enums";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Config, ConfigEnvService } from "./configEnvService";
@Injectable({
  providedIn: "root",
})
export class ApiUtilityService {
  private config: Config;
  public baseUrl = "";

  constructor(public http: HttpClient, envService: ConfigEnvService) {
    this.config = envService.getConfigData();
    this.baseUrl = this.config.serverUrl;
  }

  toastShow(message: string, type: NotifyType) {
    notify({
      rtlEnabled: true,
      message: message,
      height: 45,
      minWidth: 150,
      width: "auto",
      type: type,
      displayTime: 7000,
      animation: {
        show: {
          type: "fade",
          duration: 40,
          from: 0,
          to: 1,
        },
        hide: { type: "fade", duration: 40, to: 0 },
      },
    });
  }

  returnHttpParams(model: any) {
    let params = new HttpParams();

    Object.keys(model).forEach((key) => {
      params = params.set(key, model[key.toString()]);
    });

    return params;
  }

  getLookupAsync(value) {
    return this.http.get<any>(`${this.baseUrl}api/common/LookupAsync/${value}`);
  }
}
